import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="update-die-price"
export default class extends Controller {
  connect() {
    console.log("updateDiePriceController connected");
  }

  async update(event) {
    const id = event.target.closest("td").dataset.id;
    const price = event.target.value;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/die_price_lists/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ die_price_list: { price } })
    });

    if (response.ok) {
      const alert = document.createElement("div");
      alert.className =
        "alert alert-success alert-dismissible alert-position text-center";
      alert.innerHTML = `
         更新しました。
         <button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button>
       `;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    }
  }
}
